const homepage_tour = {
	steps: {
		company: {
			description: "Hier kunt u de gegevens van uw bedrijf inzien en bewerken.",
			title: "Bedrijf",
		},
		firstview: {
			description:
				"U kunt ervoor kiezen om een korte rondleiding te starten (ongeveer 1 minuut) zodat u weet wat de portal kan en waar u gegevens en producten kunt vinden.",
			title: "Welkom op de Tuxis Portal",
		},

		homepage: {
			description:
				"Hier hebt u een overzicht van de afgenomen diensten. Als u naar deze hoofdpagina wil terugkeren, klik dan op het Tuxis logo bovenin in de linker zijbalk.",
			title: "Hoofdpagina",
		},

		personal: {
			business: {
				description:
					"Instellingen en gegevens voor uw persoonlijke account vindt u hier waaronder uw wachtwoordkluis, SSH-keys, e-mailadressen voor meldingen en twee-factor authenticatie (2FA). \nFunctionele zaken zoals het wachtwoord wijzigen en communicatie taal instellen vind u ook hier.",
			},
			private: {
				description:
					"Instellingen en gegevens voor uw persoonlijke account vindt u hier waaronder uw wachtwoordkluis, SSH-keys, e-mailadressen voor storingen en 2FA.\nFunctionele zaken zoals het wachtwoord wijzigen en communicatie taal instellen vind u ook hier.",
			},
			title: "Persoonlijk",
		},

		products_and_services: {
			description:
				"Dit is de plek waar u producten en diensten beheerd. Hier kunt u nieuwe producten en diensten aanmaken of bestellen, bewerken en beëindigen.",
			title: "Producten en diensten",
		},

		relations: {
			description:
				"Met relaties kunt u producten en diensten aan een persoon, company of afdeling koppelen. Hierdoor houd u het overzicht welke producten u voor wie heeft aangemaakt.",
			title: "Relaties",
		},

		shortcuts: {
			description:
				"Hier kunt u snelkoppelingen vinden om te schakelen tussen licht en donker thema, uit te loggen, gedeelde wachtwoorden te beheren en problemen te melden.",
			title: "Snelkoppelingen",
		},

		username: {
			description: "Hier kunt u uitloggen en controleren als wie u bent ingelogd.",
			title: "Gebruikersnaam",
		},
	},
};

export default homepage_tour;
